import router from '../router'
import VueTk from '@moke/vue-tk'
import store from '@/store'
const rulers = [{ // 登录判断
  match: '*',
  except: [
    '/user/login',
    '/exception/403',
    '/exception/404',
    '/exception/200',
    '/account/setting/base',
    '/account/setting/editPassWord'
  ],
  // handler: (route, next) => next(!!store.state.user && !!store.state.sessionToken),
  handler: (route, next) => {
    const all = [
      '/',
      '/User',
      '/workShop',
      '/model',
      '/proportion',
      '/rawMaterial',
      '/product/parts',
      '/product/finishProduct',
      '/product/finishSurcharge',
      '/product/batchingFinishProductUn',
      '/product/batchingFinishProduct',
      '/product/batchingSurcharge',
      '/order',
      '/client',
      '/company',
      '/allPallet',
      '/allPack',
      '/allMark',
      '/setting',
      '/clientCommission',
      '/salary',
      '/profit',
      '/completeOrder',
      '/model/unconfirmedOrder',
      '/confirmedOrder',
      '/model/priceLog',
      '/model/finishProductLog',
      '/model/batchingLog',
      '/model/sentOrder',
      // '/deliveriesTakedOrder',
      '/financeVerifyOrder',
      '/model/unconfirmedOrder2',
      '/reserveOrder',
      '/model/docs',
      '/test'
    ]
    if (store.state.user) {
      if (all.indexOf(route.path) === -1) {
        // 不可访问地址
        next('/exception/404')
      } else if (Object.keys(store.state.user).indexOf('authority') === -1) {
        next('/exception/403')
      } else {
        next(!!store.state.user)
      }
    } else {
      next('/user/login')
    }
    // const jurisdiction = {
    //   sale: ['/', '/product/finishProduct', '/product/batchingFinishProduct', '/order', '/model/client', '/model/deliveriesTakedOrder'], // 销售可以访问的页面
    //   finance: ['/product/finishProduct', '/product/batchingFinishProduct', '/model/clientCommission', '/model/salary', '/model/profit', '/model/confirmedOrder'], // 财务可以访问的页面
    //   workshop: ['/', '/product/finishProduct', '/product/batchingFinishProductUn', '/product/batchingFinishProduct', '/order'], // 车间经理可以访问的页面
    //   staff: ['/', '/order', '/model/completeOrder', '/model/unconfirmedOrder']
    // }
    // let adminRole = ''
    // // 没有登录去登录页
    // if (store.state.user) {
    //   // 获取身份
    //   adminRole = store.state.user.adminRole
    //   if (all.indexOf(route.path) === -1) {
    //     // 不可访问地址
    //     next('/exception/404')
    //   } else if (adminRole !== 'admin') {
    //     if (jurisdiction[adminRole].indexOf(route.path) === -1) {
    //       // 没有权限
    //       next('/exception/403')
    //     } else {
    //       next(!!store.state.user)
    //     }
    //   } else {
    //     next(!!store.state.user)
    //   }
    // } else {
    //   next('/user/login')
    // }
  },
  fallbackUrl: '/user/login'
}]

VueTk.tkRouterAuth.init(rulers, router)
